import { makeStyles, Tab, Tabs, Tooltip } from "@material-ui/core";

import { getCampaign_campaign } from "src/graphql/generated/getCampaign";
import palette from "src/styles/palette";

export type ContactSource = "CSV" | "VAN";

export type ImportStatus = "PREPARING" | "IN_PROGRESS" | "DONE";

const useStyles = makeStyles(() => ({
  root: {
    borderBottom: `1px solid ${palette.lightGray}`
  }
}));

const ContactSources: React.FC<{
  campaign: getCampaign_campaign;
  selectedSource?: ContactSource | null;
  onSelectSource?: (source: ContactSource) => any;
  disabled: boolean;
}> = ({ campaign, selectedSource, onSelectSource, disabled }) => {
  const classes = useStyles();

  const tabDisabled = (value: ContactSource) =>
    disabled && selectedSource !== value;

  return (
    <Tabs
      value={selectedSource}
      onChange={(_, newSource) => {
        if (newSource !== selectedSource && onSelectSource) {
          onSelectSource(newSource);
        }
      }}
      indicatorColor="primary"
      classes={classes}
    >
      <Tab value="CSV" label="Upload a CSV" disabled={tabDisabled("CSV")} />
      {campaign.vanIntegration ? (
        <Tab
          value="VAN"
          label="Import from NGP VAN"
          disabled={tabDisabled("VAN")}
        />
      ) : (
        <Tooltip
          title="Campaign is not linked to an NGP VAN integration"
          placement="top"
        >
          <span style={{ width: "fit-content" }}>
            <Tab value="VAN" label="Import from NGP VAN" disabled />
          </span>
        </Tooltip>
      )}
    </Tabs>
  );
};

export default ContactSources;
